/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../styles/variables';
import AccessibleSVG, { SVGProps } from '../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const MonthlyReport56 = (props: SVGProps) => (
    <AccessibleSVG width={56} height={56} viewBox="0 0 56 56" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                fill={vars.bdlBoxBlue10}
                d="M20 36a8 8 0 110 16 8 8 0 010-16zM48 4c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4z"
            />
            <path
                fill={vars.bdlBoxBlue10}
                fillRule="nonzero"
                d="M45 10c2.21 0 4 1.79 4 4v28c0 2.21-1.79 4-4 4H11a4 4 0 01-4-4V14c0-2.21 1.79-4 4-4h34z"
            />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M45 8H11a6 6 0 00-6 6v28a6 6 0 006 6h34a6 6 0 006-6V14a6 6 0 00-6-6zm0 2c2.21 0 4 1.79 4 4v28c0 2.21-1.79 4-4 4H11c-2.21 0-4-1.79-4-4V14c0-2.21 1.79-4 4-4h34z"
            />
            <path fill={vars.white} fillRule="nonzero" d="M47 16v26a2 2 0 01-2 2H11a2 2 0 01-2-2V16h38z" />
            <path
                fill={vars.bdlBoxBlue10}
                fillRule="nonzero"
                d="M45 10c2.21 0 4 1.79 4 4v2H7v-2c0-2.21 1.79-4 4-4h34zm0 1H11a3 3 0 00-2.995 2.824L8 14v1h40v-1a3 3 0 00-2.824-2.995L45 11z"
            />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M51 15v1h-3v26a3 3 0 01-2.824 2.995L45 45H11a3 3 0 01-3-3V16H5v-1h46zm-4 1H9v26a2 2 0 002 2h34a2 2 0 002-2V16z"
            />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M37.6 22.7l.8.6-6.284 8.378-6.053-4.035-5.709 5.711-.708-.708 6.29-6.289 5.948 3.964z"
            />
            <path fill={vars.bdlBoxBlue} fillRule="nonzero" d="M26 25a2 2 0 11.001 3.999A2 2 0 0126 25z" />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M26 25a2 2 0 11.001 3.999A2 2 0 0126 25zm-6 5a2 2 0 11.001 3.999A2 2 0 0120 30zm11.992-1a2 2 0 11.001 3.999A2 2 0 0131.992 29zm5.993-8a2 2 0 110 4 2 2 0 010-4z"
            />
            <g fillRule="nonzero">
                <path fill={vars.bdlBoxBlue} d="M17 5a3 3 0 013 3v2a3 3 0 11-6 0V8a3 3 0 013-3z" />
                <path
                    fill={vars.bdlBoxBlue10}
                    d="M17 7a1 1 0 00-.993.883L16 8v2a1 1 0 001.993.117L18 10V8a1 1 0 00-1-1z"
                />
            </g>
            <g fillRule="nonzero">
                <path
                    fill={vars.bdlBoxBlue}
                    d="M39 5a3 3 0 013 3v2a3 3 0 11-6 0V8a3 3 0 013-3zm0 2a1 1 0 00-.993.883L38 8v2a1 1 0 001.993.117L40 10V8a1 1 0 00-1-1z"
                />
                <path
                    fill={vars.bdlBoxBlue10}
                    d="M39 7a1 1 0 00-.993.883L38 8v2a1 1 0 001.993.117L40 10V8a1 1 0 00-1-1z"
                />
            </g>
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M13.5 20a.5.5 0 01.492.41l.008.09v18a.5.5 0 00.41.492l.09.008h28a.5.5 0 01.09.992L42.5 40h-28a1.5 1.5 0 01-1.493-1.356L13 38.5v-18a.5.5 0 01.5-.5z"
            />
        </g>
    </AccessibleSVG>
);

export default MonthlyReport56;
